<script lang="ts">
  import ViewLeaveRequest from '../../components/employer/leaveRequest/ViewLeaveRequest.svelte';
  import { location } from 'svelte-spa-router';
  
  // Extract the request ID from the URL params reactively
  $: {
    const params = new URLSearchParams($location.split('?')[1] || '');
    requestId = params.get('id') || '';
  }
  
  let requestId = '';
</script>

<ViewLeaveRequest {requestId} /> 